import React from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { Text } from '@amzn/atoz-web/Text';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { View } from '@amzn/atoz-web/View';
import { LoadingButton } from '../../shared';
import { useAddOpportunityModalContent } from './useAddOpportunityModalContent';
export var AddOpportunityModalContent = function (_a) {
    var close = _a.close, shiftOpportunity = _a.shiftOpportunity, onAddOpportunity = _a.onAddOpportunity, loading = _a.loading;
    var t = useTranslation().t;
    var _b = useAddOpportunityModalContent({
        shiftOpportunity: shiftOpportunity
    }), modalTitle = _b.modalTitle, modalText = _b.modalText, modalBannerText = _b.modalBannerText;
    var addButton = (React.createElement(LoadingButton, { key: "AddOpportunityButton", loading: loading, onClick: onAddOpportunity, spinnerColor: SpinnerColorScheme.Inverted, dataTestId: "AddOpportunityModalButton", ariaLabel: t('shift_management_features_AddOpportunityModalButton_buttonLabel'), buttonText: t('shift_management_features_AddOpportunityModalContentButton_buttonText') }));
    return (React.createElement(ModalContent, { dataTestId: "AddOpportunityModalContent", titleText: modalTitle, buttons: [addButton], onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(Text, { margin: { bottom: 'S200' } }, modalText),
        React.createElement(MessageBanner, { type: MessageBannerType.Warning },
            React.createElement(View, { display: "flex" }, modalBannerText))));
};
